var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkAsReadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.499878,
    width: 23,
    height: 23,
    rx: 4.5,
    stroke: "#93B0C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.99988,
    width: 16,
    height: 16,
    fill: "#3F7DBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.9999C7.286 21.9999 4.929 21.9999 3.464 20.5349C2 19.0719 2 16.7139 2 11.9999C2 7.28588 2 4.92888 3.464 3.46388C4.93 1.99988 7.286 1.99988 12 1.99988C16.714 1.99988 19.071 1.99988 20.535 3.46388C22 4.92988 22 7.28588 22 11.9999C22 16.7139 22 19.0709 20.535 20.5349C19.072 21.9999 16.714 21.9999 12 21.9999ZM14.474 8.41888C14.628 8.54462 14.7259 8.72639 14.7459 8.92422C14.766 9.12206 14.7067 9.31977 14.581 9.47388L8.867 16.4739C8.79666 16.56 8.70804 16.6295 8.60755 16.6772C8.50707 16.7249 8.39723 16.7496 8.286 16.7496C8.17477 16.7496 8.06493 16.7249 7.96445 16.6772C7.86396 16.6295 7.77534 16.56 7.705 16.4739L5.419 13.6739C5.29835 13.5193 5.24305 13.3236 5.26494 13.1287C5.28684 12.9338 5.38419 12.7553 5.53614 12.6313C5.68809 12.5073 5.88255 12.4478 6.07786 12.4655C6.27316 12.4832 6.45378 12.5766 6.581 12.7259L8.286 14.8139L13.419 8.52588C13.5447 8.37183 13.7265 8.27402 13.9243 8.25395C14.1222 8.23389 14.3199 8.29321 14.474 8.41888ZM18.474 8.41888C18.6281 8.54462 18.7259 8.72639 18.7459 8.92422C18.766 9.12206 18.7067 9.31977 18.581 9.47388L12.867 16.4739C12.7924 16.5655 12.6973 16.6382 12.5894 16.686C12.4814 16.7339 12.3637 16.7556 12.2457 16.7493C12.1278 16.7431 12.013 16.7091 11.9107 16.6501C11.8084 16.5911 11.7215 16.5088 11.657 16.4099L11.372 15.9719C11.2863 15.8404 11.244 15.6854 11.2511 15.5286C11.2582 15.3718 11.3143 15.2212 11.4114 15.098C11.5086 14.9748 11.642 14.8851 11.7928 14.8417C11.9435 14.7983 12.1042 14.8032 12.252 14.8559L17.419 8.52588C17.5447 8.37183 17.7265 8.27402 17.9243 8.25395C18.1222 8.23389 18.3199 8.29321 18.474 8.41888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsReadIcon);
export default __webpack_public_path__ + "static/media/markAsReadIcon.39125a96181c546a62e6a53df7187e39.svg";
export { ForwardRef as ReactComponent };